import api from "./api";

export interface ServiceCta {
  label: string;
  url: string;
}

export interface ServiceMeta {
  tagline?: string | null;
  cta?: {
    primary?: ServiceCta | null;
    secondary?: ServiceCta | null;
  };
}

export interface ServiceItem {
  id: string;
  slug: string;
  title: string;
  summary: string | null;
  description: string | null;
  image_url: string | null;
  category: string | null;
  keywords: string[];
  meta: ServiceMeta | null;
  status: string;
  display_order: number;
  created_at: string;
  updated_at: string;
}

export interface ServiceListResponse {
  total: number;
  items: ServiceItem[];
}

export interface ServiceCategoryRow {
  name: string;
  count: number;
}

export const servicesService = {
  list: async (params?: { category?: string }): Promise<ServiceListResponse> => {
    const { data } = await api.get<ServiceListResponse>("/services", { params });
    return data;
  },

  listCategories: async (): Promise<ServiceCategoryRow[]> => {
    const { data } = await api.get<{ categories: ServiceCategoryRow[] }>(
      "/services/categories",
    );
    return data.categories;
  },

  getBySlug: async (slug: string): Promise<ServiceItem> => {
    const { data } = await api.get<ServiceItem>(`/services/${slug}`);
    return data;
  },
};
